export default __webpack_public_path__ + "static/media/Gshar-Products34.89de9ced.jpg";